/* eslint no-param-reassign: ["error", { "props": false }] */

export default function(view, data) {
  // make forEach available on NodeList
  NodeList.prototype.forEach = Array.prototype.forEach;

  // bail out if no data
  if (!data) {
    return;
  }

  // loop through each item in the data array
  data.items[0].tables.forEach((dataItem) => {
    // find dom items that match the current data row
    const items = document.querySelectorAll(`[data-round="${dataItem.round.id}"]`);

    // loop through matching dom items and attach the update function
    items.forEach((item) => {
      // if update function is not bound, add it
      // push data with firstRun param set to true
      if (!item.update) {
        item.update = view;
        item.update(dataItem, true);
      } else {
        item.update(dataItem);
      }
    });
  });
}
